import api from "@/services/api.service";
import { ActionTree } from "vuex";
import { DeviceType, DeviceTypeSearchParams, EventSearchState } from "./types";
import { RootState } from "../types";
import { formatDateMixin } from "@/mixins";
import { devicesApi } from "@/services/api.devices.service";
const { currentDateFormatted, weekAgoDateFormatted } = formatDateMixin.methods;
import PaginatedSearch from "@/mixins/PaginatedSearch";

const defaultSearchFilter = {
	from: weekAgoDateFormatted(),
	until: currentDateFormatted(),
	groupID: 1
};

export const actions: ActionTree<EventSearchState, RootState> = {
	async loadEvents({ commit }, filter = defaultSearchFilter) {
		commit("setCacheKey", null);
		commit("setTotalEvents", null);
		commit("setEvents", []);
		commit("setSearching", true);
		const events = await api.eventSearch(filter);
		commit("setEvents", events);
		commit("setSearching", false);
	},

	async loadSearchableEventTypes({ state, commit }) {
		const searchableEventsNotSet = state.SearchableEventTypes.length === 0;
		if (searchableEventsNotSet) {
			const searchableEventTypes = await api.loadSearchableEventTypes();
			commit("setSearchableEventTypes", searchableEventTypes);
		}
		// else we already loaded the event types from the api so there's nothing to do
	},

	async loadDeviceTypes({ commit }, params: DeviceTypeSearchParams = {}) {
		let request;

		// if there's no search term send a request with no cancel token
		if (!params.searchTerm) {
			request = {
				page: 1,
				pageSize: 25,
				cancellationToken: null
			}
		} else {
			const paginatedSearch = new PaginatedSearch();
			request = paginatedSearch.generateNewPaginatedSearchRequest({
				page: 1,
				pageSize: 25,
				searchTerm: params.searchTerm
			});
		}

		let deviceTypes: DeviceType[] = await devicesApi.getAllDeviceTypes(request);

		// If a selected device type is provided and not in the new results, add it
		if (
			params.selectedDeviceType &&
			!deviceTypes.some(dt => dt.serverTypeID === params.selectedDeviceType.serverTypeID)
		) {
			deviceTypes.unshift(params.selectedDeviceType);
		}

		commit("setDeviceTypes", deviceTypes);
	},

	async loadOperators({ commit }) {
		const operators = await api.loadAvailableEventOperators();
		commit("setOperators", operators);
	},

	async loadEventCategories({ commit }) {
		const categories = await api.loadAvailableEventCategories();
		commit("setCategories", categories);
	},

	async loadAlarmTypes({ commit }, serverTypeID: number) {
		const alarmTypes = await api.loadAlarmTypes(serverTypeID);
		commit("setAlarmTypes", alarmTypes);
	},

	async loadPaginatedEvents({ commit }, { newSearch, filter }) {
		var data = await api.paginatedEventSearch(filter);
		if (newSearch == true) {
			commit("setEvents", data.eventSearchResult);
		} else {
			commit("appendPaginatedEvents", data.eventSearchResult);
		}
		commit("setCacheKey", data.cacheKey);
		commit("setTotalEvents", data.totalResults);
	}
};
